var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('img',_vm._g(_vm._b({attrs:{"width":"30","src":require(`@/assets/images/icons/${_vm.img.src}`),"alt":_vm.img.alt}},'img',attrs,false),on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.img.tool_tip_text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }